// extracted by mini-css-extract-plugin
export default {"ProjectTaskList":"projectTaskList_ProjectTaskList__w2aRI","empty_wrap":"projectTaskList_empty_wrap__YCQ05"};